/** Must match ZkAttendanceApi.Helpers.CsrfProtection */
export const CSRF_PROTECTION_HEADER = 'X-CSRF-Protection';
export const CSRF_PROTECTION_VALUE = '1';
